export const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp"
]

const GENERIC_UPLOAD_TYPES = new Set([
  "",
  "application/octet-stream",
  "application/binary",
  "binary/octet-stream",
  "application/x-binary"
])

const CONTENT_TYPE_BY_EXTENSION = new Map([
  ["jpg", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["png", "image/png"],
  ["webp", "image/webp"],
  ["gif", "image/gif"],
  ["mp4", "video/mp4"],
  ["m4v", "video/x-m4v"],
  ["mov", "video/quicktime"],
  ["webm", "video/webm"],
  ["avi", "video/x-msvideo"],
  ["mkv", "video/x-matroska"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["ogv", "video/ogg"],
  ["3gp", "video/3gpp"],
  ["3g2", "video/3gpp2"],
  ["ts", "video/mp2t"],
  ["mts", "video/mp2t"],
  ["m2ts", "video/mp2t"]
])

export const isAllowedImageType = (mimeType) => {
  return ALLOWED_IMAGE_TYPES.includes(normalizeMimeType(mimeType))
}

export const targetMediaTypeFor = (file) => {
  const mimeType = normalizeMimeType(file?.type)
  if (!isGenericUploadType(mimeType)) return mimeType

  return CONTENT_TYPE_BY_EXTENSION.get(fileExtension(file?.name)) || mimeType
}

export const isAllowedTargetMedia = (file) => {
  const mimeType = targetMediaTypeFor(file)
  return isAllowedImageType(mimeType) || mimeType === "image/gif" || mimeType.startsWith("video/")
}

export const isAllowedBasePhoto = (file) => isAllowedImageType(targetMediaTypeFor(file))

export const isPickerImage = (file) => isAllowedBasePhoto(file)

const normalizeMimeType = (mimeType) => mimeType?.toString().split(";", 1)[0].trim().toLowerCase() || ""

const isGenericUploadType = (mimeType) => {
  return GENERIC_UPLOAD_TYPES.has(mimeType) || mimeType.endsWith("/octet-stream")
}

const fileExtension = (filename) => {
  const match = filename?.toString().toLowerCase().match(/\.([a-z0-9]+)$/)
  return match?.[1] || ""
}
